//import liraries
import React, { useState, useEffect } from "react";
import {View, Text, Image, TouchableOpacity, Pressable, Linking, Animated} from "react-native";
import DashboardCard from "./DashboardCard";
import UserDetails from "./UserDetails";
import {getPoolAccountdetail, getAllVehiclesListApi, getOffers} from "../../api/apiManager";
import {postHitBanner,} from "../../api/serviceRequest";
import Loader from "./../../common/Loader";
import GetMaxAnimatedButton from "./../../common/GetMaxAnimatedButton";
import AsyncStorageFunc from "../../utilities/asyncStorage";
import * as RootNavigation from "../../utilities/RootNavigation";
import { useLogin } from '../../context/loginProvider';
import OfferCard from "./OfferCard";
import TransactionCard from "./TransactionCard";
import { useApiContext } from "../../api/ApiContext";
import { isEmpty } from "lodash";
import{ucl_offer_data, ucl_offer_data_web} from "../../constant/dataHelper"
import CImage from "../../common/CImage";
import useStyles from "./DashboardComponent_Styles";

// create a component
export default function DashboardComponent(props) {
  const styles = useStyles();
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [offerListWeb, setOfferListWeb] = useState([])
  const [animation, setAnimation] = useState(new Animated.Value(0))
  const [poolBalance, setPoolBalance] = useState("");
  // const [allVehiclesBalance, setAllVehiclesBalance] = useState(0);
  const [vehicleDetails, setVehicleDetails] = useState("");
  const { offerList, setOfferList,  allVehiclesBalance, setAllVehiclesBalance, setVehicleList} = useApiContext();

  useEffect(() => {
    getOfferList()
    getPoolAccountDtls();
    geAllVehicle();
    setInterval(() => {
      handleAnimation()//i get ran every 5 seconds
    }, 1500)
  }, [])

  useEffect(() => {
    if (offerList?.length > 0) {
      let webOffer  = offerList.map((item) => {
        if (item.headLine == "Savings" && !item?.webPath)
          return {
            ...item,
            banner: require("../../assets/images/SavingBanner.png"),
          };
        else if (item.headLine == "Credit Card" && !item?.webPath)
          return {
            ...item,
            banner: require("../../assets/images/credit_banner.png"),
          };
        else if (item.headLine == "Car Loan")
          return {
            ...item,
            banner: require("../../assets/images/UCL_WEB.png"),
          };
        else
          return {
            ...item,
            banner: item?.webPath ? item?.webPath : "",
          };
      });
      setOfferListWeb(webOffer)
    }
  }, [offerList])

  useEffect(() => {
    if (vehicleDetails.length > 0) {setVehicleDetails(vehicleDetails) }
  }, [vehicleDetails])

  useEffect(() => {
    if (poolBalance.length > 0) { setPoolBalance(poolBalance)}
  }, [poolBalance])

  const handleAnimation = () => {
    Animated.timing(animation, {
      toValue: 1,
      duration: 1000,
      useNativeDriver: true 
    }).start(() => {
      Animated.timing(animation, {
        toValue: 0,
        duration: 1000,
        useNativeDriver: true 
      }).start()
    })
  }

  const getOfferList = () => {
    // Check if offerList is empty or null
    if (!offerList || offerList.length === 0) { 
      getOffers().then((res) => {
        var data = res?.data;
        data = data?.filter((item) => item?.headLine != "Consumer Durable");
        // let webOffers = data ? [...data, ...ucl_offer_data_web] : null;
        let webOffers = data ? [...data] : null;

        data = data?.map((item) => {
          if (item) {
            if (item.headLine == "Savings") {
              return {
                ...item,
                banner: require("../../assets/images/saving_mobile.png"),
                bannerTab: require("../../assets/images/savings_tab_banner.png"),
              };
            } else if (item.headLine == "Credit Card") {
              return {
                ...item,
                banner: require("../../assets/images/creditcard_mobile.png"),
                bannerTab: require("../../assets/images/creditcard_mobile.png"),
              };
            } else if (item.headLine == "Used Car Loan") {
              global.UCLURL = item?.actionTxt
              return {
                ...item,
                banner: require("../../assets/images/UCL_MOBILE.png"),
                bannerTab: require("../../assets/images/UCL_banner_tab.png"),
              };
            } else
              return {
                ...item,
                banner: item?.mobilePath ? item?.mobilePath : "",
                bannerTab: item?.tabPath ? item?.tabPath : "",
              };
          }
        });
        //for web :
        webOffers = webOffers?.map((item) => {
          if (item.headLine == "Savings" && !item?.webPath)
            return {
              ...item,
              banner: require("../../assets/images/SavingBanner.png"),
            };
          else if (item.headLine == "Credit Card" && !item?.webPath)
            return {
              ...item,
              banner: require("../../assets/images/credit_banner.png"),
            };
          else if (item.headLine == "Used Car Loan"  && !item?.webPath)
            return {
              ...item,
              banner: require("../../assets/images/UCL_WEB.png"),
            };
          else
            return {
              ...item,
              banner: item?.webPath ? item?.webPath : "",
            };
        });
        setOfferList(data);
        setOfferListWeb(webOffers);
        setInterval(() => {
          setActiveIndex((prevCount) =>
            data?.length - 1 === prevCount ? 0 : prevCount + 1
          );
        }, 10000); // execute every 10 seconds
      });}
  };

  const geAllVehicle = () => {
    if (isEmpty(vehicleDetails) || vehicleDetails === 0) {
      setLoading(true);  
      getAllVehiclesListApi()
        .then((res) => {
          var negatives = [];
          var sum = 0;
          for (var i = 0; i < res.length; i++) {
            if (res[i].fastagBalance < 0) {
              sum += res[i].fastagBalance;
            } 
          }
          setAllVehiclesBalance(sum);
          setLoading(false);
          if (res?.length) {
            setVehicleDetails(res[0])
            setVehicleList(res)
          };
        })
        .catch((err) => {
          setLoading(false);
          if (err?.message == "Invalid token specified") {
            setIsLoggedIn(false)
          } }); };
  }

  const getPoolAccountDtls = () => {
    if (!poolBalance || poolBalance.length === 0) {
      setLoading(true);
      getPoolAccountdetail()
        .then((res) => {
          setLoading(false);
          setPoolBalance(res?.accountBal || 0);
          AsyncStorageFunc.storeData("POOL_ACNT_NBR", res?.accountNo || 0);
        })
        .catch((err) => {
          setLoading(false);
          if (err?.message == "Invalid token specified") {
            setIsLoggedIn(false)
     } });
    } };

  const onPressBanerCallApi = (item) => {
    const params = { bannerType: item.headLine };
    postHitBanner(params).then((res) => { console.log("HIT_BANNER_SUCCESS", res);});
  }
  let totalBalance = poolBalance + allVehiclesBalance
  const onPressMaxPro = () => {
    global.selectedVehicleForMax = vehicleDetails?.vrn
    global.mpExipryDate = vehicleDetails?.maxProExpiryDate
    global.optIn = true
    global.navFromDB = true
    global.navFromVD = false
    global.navFromOS = false
    RootNavigation.navigate("OtherServices/maxpro", { screen: "alignedServices", })
    global.activeScreen = "UsedCarLoan"
  }

  const onPressOptMaxPro = () => {
    global.selectedVehicleForMax = ''
    global.mpExipryDate = ''
    global.optIn = false
    global.navFromDB = true
    global.navFromVD = false
    global.navFromOS = false
    RootNavigation.navigate("OtherServices/maxpro", { screen: "alignedServices", })
    global.activeScreen = "UsedCarLoan"
  }

  return (
    <View style={styles.container}>
      <View style={styles.dashboard_headerCards}>
        <View style={styles.dashboard_headerCards_layoutBoxes}>
          <View style={styles.desktopView}>
            <TouchableOpacity
              onPress={() => {RootNavigation.navigate("Profile/My\nVehicles")
                global.activeScreen = "Profile"
              }}
              style={styles.maroonCardStyle}
            >
              <View style={[styles.maroonCardContent]}>
                <View style={{ flexDirection: 'row' }} >
                  <Text style={[styles.cardVrnTextStyle, { width: 140 }]} ellipsizeMode='head' numberOfLines={2} >{vehicleDetails?.vrn}</Text>
                </View>
                <Text style={styles.cardTextStyle1}> {"View all Registered Vehicles"} </Text>
              </View>
              {vehicleDetails && vehicleDetails?.vrn.length > 1 ?
                <View style={[styles.maroonCardIcon,]}>
                  {vehicleDetails?.maxProStatus == "Enabled" && vehicleDetails?.vrn != "" ? <GetMaxAnimatedButton isOpted onPress={() => onPressMaxPro()} /> : <GetMaxAnimatedButton onPress={() => onPressOptMaxPro()} />}
                </View> : null}
            </TouchableOpacity>
          </View>
          <View style={styles.mobileAddVehicle}>
            <TouchableOpacity style={styles.maroonCardStyle}>
              <View style={[styles.maroonCardContent]}>
                <View style={{ flexDirection: 'row' }}>
                  <Text style={[styles.cardTextStyle,]}>{vehicleDetails?.vrn}</Text>
                </View>
                <View style={{ flexDirection: "row", }}>
                  <TouchableOpacity
                    onPress={() => { RootNavigation.navigate("Profile/MyVehicles")
                      global.activeScreen = "Profile"
                    }}>
                    <View style={styles.iconWidget}>
                      <Text style={styles.cardTextStyle1}> {"View all Vehicles "} </Text>
                      <CImage.NavIconRight></CImage.NavIconRight>
                    </View>
                  </TouchableOpacity>
                 
                </View>
              </View>
              <View style={styles.maroonCardIcon}>
                {vehicleDetails?.maxProStatus == "Enabled" ? <GetMaxAnimatedButton isOpted onPress={() => onPressMaxPro()} /> : <GetMaxAnimatedButton onPress={() => onPressOptMaxPro()} /> }
              </View>
            </TouchableOpacity>
          </View>
        </View>

        <View style={styles.dashboard_headerCards_layoutBoxes}>
          <View style={styles.maroonCardStyle}>
            <View style={styles.maroonCardContent}>
              <Text style={styles.cardTextStyle}>
                {console.log(props?.totalBalance,'totalBalance')}
                  { props?.totalBalance =="NaN"? "0.00": props?.totalBalance}
              </Text>
              <View style={{ flexDirection: "row" }}>
                <Text style={styles.cardTextStyle1}> {"Account Balance"}</Text>
                <TouchableOpacity
                  onPress={() => {
                    global.selectedPoolNbr = "";
                    global.selectedPollAcntBal = "";
                    global.selectedVehilce = "";
                    global.selectedVehilceFastBal = "";
                    RootNavigation.navigate("Recharge")
                    global.activeScreen = "Recharge"
                  }}
                  style={styles.mobileRechargeViewStyle}
                >
                  <Text style={styles.cardTextStyle1}> {"Recharge"} </Text>
                  <CImage.NavIconRight></CImage.NavIconRight>
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.maroonCardIcon1}>
              <Image source={require("../../assets/images/Pool_Account_Balance_yellow.png")} style={styles.iconStyle} />
            </View>
            <View style={styles.maroonCardIconMobile1}>
              <Image source={require("../../assets/images/Add_Money_Icon.png")} style={styles.iconStyle} />
            </View>
          </View>
        </View>

        <View style={styles.dashboard_headerCards_layoutBoxes1}>
          <TouchableOpacity
            onPress={() => {
              global.selectedPoolNbr = "";
              global.selectedPollAcntBal = "";
              global.selectedVehilce = "";
              global.selectedVehilceFastBal = "";
              RootNavigation.navigate("Recharge")
              global.activeScreen = "Recharge"
            }}
            style={styles.maroonCardStyle}
          >
            <View style={styles.maroonCardContent}>
              <Text style={styles.cardTextStyle}>{"Add Money"}</Text>
              <Text style={styles.cardTextStyle1}>{"Quick Recharge"}</Text>
            </View>
            <View style={styles.maroonCardIcon}>
              <Image source={require("../../assets/images/Add_Money_Icon.png")} style={styles.iconStyle} />
            </View>
          </TouchableOpacity>
        </View>
        <View style={styles.dashboard_headerCards_layoutBoxesQL}>
          <View style={styles.tabViewQuickLinksStyle}>
            <View style={styles.tabViewQuickLinks_TextContainer}>
              <TouchableOpacity
                onPress={() => {
                  RootNavigation.navigate("Transfer")
                  global.activeScreen = "Transfer"
                }} >
                <Text style={styles.textStyle}>{"Fund Transfer"}</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  RootNavigation.navigate("Profile/MyVehicles", { screen: "My\nVehicles", })
                  global.activeScreen = "Profile"
                }} >
                <Text style={styles.textStyle}>{"My Vehicles"}</Text>
              </TouchableOpacity>
            </View>
            <View style={styles.quicklinkIconViewStyle}>
              <Image source={require("../../assets/images/Quick_Links_Icon_white.png")} style={styles.quicklinksIconStyle}  />
            </View>
          </View>
        </View>
      </View>

       <View style={styles.userDetailsViewStyle}>
        <UserDetails updateKyc addVehicle navigation={props.navigation} />
      </View>
      <View style={styles.dashboard_advertisement}>
        {offerList?.length ?
          <Pressable
            onPress={() => {
              onPressBanerCallApi(offerList[activeIndex])
              if (offerList[activeIndex].headLine == "Car Loan") {
                RootNavigation.navigate("OtherServices/UsedCarLoan", { screen: "loan", })
                global.activeScreen = "UsedCarLoan"
              } else {
                Linking.openURL(offerList[activeIndex].actionTxt);
              }
            }}>
            <Text>
              <Image
                source={
                  offerList[activeIndex]?.webPath
                    ? { uri: `data:image/png;base64,${offerList[activeIndex]?.mobilePath}`,}
                    : offerList[activeIndex]?.banner
                }
                style={styles.mobileBanner}  />
            </Text>
          </Pressable> : null}
      </View>
      <View style={styles.dashboard_advertisement}>
        {offerList?.length ?
          <Pressable
            onPress={() => {
              onPressBanerCallApi(offerList[activeIndex])
              if (offerList[activeIndex].headLine == "Car Loan") {
                RootNavigation.navigate("OtherServices/UsedCarLoan", { screen: "loan", })
                global.activeScreen = "OtherServices"
              } else { Linking.openURL(offerList[activeIndex].actionTxt); }
            }} >
            <Text>
              <Image
                source={
                  offerList[activeIndex]?.webPath
                    ? { uri: `data:image/png;base64,${offerList[activeIndex]?.tabPath}`,}
                    : offerList[activeIndex]?.bannerTab
                }
                style={styles.tabBanner} />
            </Text>
          </Pressable> : null}
      </View> 
      <View style={styles.dashboardmaroonCardContent}>
        <DashboardCard
          expenseStatistics
          navigation={props.navigation}
        />
        <TransactionCard navigation={props.navigation} vrn={vehicleDetails?.vrn} isShowSidebar={props.isShowSidebar}/>
        <View style={styles.bannerViewStyle}>
          <OfferCard offerList={offerListWeb} />
        </View>
      </View>
      {loading && <Loader />}
    </View>
  );
}

